// Viewer choices use independent style/size values and exact variant artwork.
(function () {
  'use strict';
  function boot() {
    var root = document.querySelector('.tb-hero--viewer');
    if (!root || !root.tbHero) return;
    var api = root.tbHero, select = root.querySelector('.tb-size-select');
    var picker = root.querySelector('.tb-size-picker'), status = root.querySelector('.tb-catalog-status');
    var styles = root.querySelector('.tb-style-options'), stylePicker = root.querySelector('.tb-style-picker');
    if (!select || !picker || !styles || !stylePicker) return;
    var ca = root.dataset.locale === 'ca', prefix = root.dataset.site || '';
    var sets = new Map(), initial = JSON.parse(root.querySelector('.tb-size-data').textContent);
    var active = JSON.parse(root.querySelector('.tb-data').textContent)[0];
    var currentId = String(initial.id), currentVariant = active.vid;
    sets.set(currentId, initial.variants);
    var familyIds = new Set();
    (initial.family || []).forEach(function (group) {
      if (!group.variants || !group.variants.length) return;
      familyIds.add(String(group.id));
      sets.set(String(group.id), group.variants.map(function (map) {
        return Object.assign({}, map, {st:group.style});
      }));
    });
    var familyMaps = [];
    familyIds.forEach(function (id) {
      var records = sets.get(id) || [];
      var map = records.find(function (record) { return record.sz === active.sz; }) || records[0];
      if (map) familyMaps.push(map);
    });
    // Register siblings immediately; the general catalogue may arrive later or
    // be unavailable, and the renderer otherwise knows only the entry product.
    api.addMaps(familyMaps);
    function choices() {
      if (!familyIds.has(currentId)) return sets.get(currentId) || [];
      var records = [];
      familyIds.forEach(function (id) { records = records.concat(sets.get(id) || []); });
      return records;
    }
    function text(a, b) { return ca ? a : b; }
    function message(value) { status.textContent = value || ''; status.hidden = !value; }
    function currentMap() {
      var variants = sets.get(currentId) || [];
      return variants.find(function (m) { return String(m.vid) === String(currentVariant); }) || variants[0];
    }
    function syncPicker() {
      var variants = choices(), selected = currentMap();
      picker.hidden = !selected || (variants.length === 1 && selected.sz === 'Default Title');
      if (!selected) return;
      var sizes = Array.from(new Set(variants.map(function (m) { return m.sz; })));
      var styleNames = Array.from(new Set(variants.map(function (m) { return m.st || ''; })));
      var fragment = document.createDocumentFragment();
      sizes.forEach(function (size) {
        var option = document.createElement('option');
        option.value = size; option.textContent = size;
        option.disabled = !variants.some(function (m) { return m.sz === size && m.st === selected.st; });
        fragment.appendChild(option);
      });
      select.replaceChildren(fragment);
      select.disabled = sizes.length < 2;
      select.value = selected.sz;
      stylePicker.hidden = styleNames.length < 2;
      var signature = JSON.stringify(styleNames);
      if (styles.dataset.choices !== signature) {
        styles.dataset.choices = signature;
        styles.replaceChildren();
        styleNames.forEach(function (style) {
          var button = document.createElement('button');
          button.type = 'button'; button.className = 'tb-style-choice';
          button.dataset.style = style; button.textContent = style;
          button.addEventListener('click', function () { choose(style, select.value); });
          styles.appendChild(button);
        });
      }
      styles.querySelectorAll('button').forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.dataset.style === (selected.st || '')));
        button.disabled = !variants.some(function (m) { return (m.st || '') === button.dataset.style && m.sz === selected.sz; });
      });
    }
    function selectedMap(map) {
      active = map; currentVariant = map.vid;
      root.dataset.return = map.u;
      root.querySelector('.tb-viewer-return').href = map.u;
      var url = new URL(map.u, window.location.href);
      url.searchParams.set('view', 'trobart-viewer');
      window.history.replaceState(null, '', url.pathname + url.search);
      message();
    }
    function choose(style, size) {
      var previous = currentVariant, previousId = currentId;
      var map = choices().find(function (m) { return (m.st || '') === style && m.sz === size; });
      if (!map || String(map.vid) === String(currentVariant)) return;
      currentId = String(map.id); currentVariant = map.vid;
      syncPicker();
      message(text('Carregant el mapa…', 'Cargando el mapa…'));
      if (!api.replaceMap(map)) {
        currentId = previousId; currentVariant = previous;
        syncPicker(); message(text('No hem pogut carregar aquest mapa.', 'No hemos podido cargar este mapa.'));
      }
    }
    select.addEventListener('change', function () {
      var map = currentMap();
      if (map) choose(map.st || '', select.value);
    });
    root.addEventListener('trobart:map-change', function (event) {
      currentId = String(event.detail.id); currentVariant = event.detail.variant;
      var map = currentMap();
      if (map) selectedMap(map);
      syncPicker();
    });
    syncPicker();
    function record(product, variant) {
      if (!product.published_at || String(product.product_type).toLowerCase() === 'hoodie') return null;
      var images = product.images || [];
      function flat(image) {
        var filename = image.src.split('?')[0].split('/').pop().toLowerCase();
        return image.width >= 900 && image.height > 0 && Math.abs(image.width / image.height - 1) > 0.04 &&
          !/(framed|display|mockup|_product|story|interior|_part|_detail)/.test(filename);
      }
      var options = variant ? [variant.option1, variant.option2, variant.option3].filter(Boolean) : [];
      var sizeLabel = options.find(function (v) { return /\d+\s*[x×]\s*\d+/i.test(v); }) || (variant && variant.title) || '';
      var style = options.filter(function (v) { return v !== sizeLabel && v !== 'Default Title'; }).join(' / ');
      var size = sizeLabel.toLowerCase().replace(/×/g, 'x').replace(/\s|cm/g, '');
      var lead = variant ? images.findIndex(function (im) {
        return String(im.id) === String(variant.image_id) || (im.variant_ids || []).some(function (id) { return String(id) === String(variant.id); });
      }) : -1;
      // Each native variant's associated mockup precedes its own full print and details.
      var index = lead >= 0 ? images.findIndex(function (im, i) { return i >= lead && i <= lead + 1 && flat(im); }) : -1;
      var municipal = /^relleu-comarcal-/.test(product.handle);
      if (municipal && index < 0) return null; // Never show another style as a fallback.
      if (index < 0) index = images.findIndex(function (im) { return flat(im) && im.src.toLowerCase().includes('_' + size + '_'); });
      if (index < 0) index = images.findIndex(flat);
      if (index < 0) return null;
      var image = images[index], aspect = image.width / image.height;
      var result = {id:product.id,t:product.title,u:prefix+'/products/'+product.handle,a:aspect,w:image.width,h:image.height,img:image.src};
      if (variant) { result.vid = variant.id; result.sz = sizeLabel; result.st = style; result.u += '?variant='+variant.id; }
      // Essential-cims galleries insert a centre detail before the four quadrants.
      var detailOffset = /^mapa-150-cims-essencials-/.test(product.handle) ? 2 : 1;
      var details = images.slice(index + detailOffset, index + detailOffset + 4).filter(function (im) {
        return im.height > 0 && Math.abs(im.width / im.height - aspect) < 0.012;
      });
      if (details.length === 4) result.q = details.map(function (im) { return [im.src, im.width, im.height]; });
      return result;
    }
    async function load() {
      try {
        for (var page = 1; ; page++) {
          var controller = new AbortController();
          var timeout = setTimeout(function () { controller.abort(); }, 20000);
          var response;
          try {
            response = await fetch(root.dataset.catalogue + '?limit=250&page=' + page, {credentials:'same-origin',signal:controller.signal});
            if (!response.ok) throw new Error('Catalogue unavailable');
            var data = await response.json();
          } finally { clearTimeout(timeout); }
          if (!Array.isArray(data.products)) throw new Error('Invalid catalogue');
          var maps = [];
          data.products.forEach(function (product) {
            var variants = (product.variants || []).map(function (variant) { return record(product, variant); }).filter(Boolean);
            if (!variants.length) return;
            if (!sets.has(String(product.id))) sets.set(String(product.id), variants);
            else variants = sets.get(String(product.id));
            maps.push(variants.find(function (map) { return /^50\s*[x×]\s*70/.test(map.sz); }) || variants[0]);
          });
          api.addMaps(maps);
          if (data.products.length < 250) break;
        }
      } catch (_) { /* Current server-rendered style and size choices work offline. */ }
    }
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !event.target.closest('input,select,textarea')) window.location.assign(root.dataset.return);
    });
    load();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
